import { useCallback, useMemo, useState } from 'react'

import { F0AiChatHeader } from '@factorialco/f0-react'

import { useAiChat } from 'modules/ai/chat/useAiChat'
import { filterNonRenderableMessages } from 'modules/ai/chat/protocol/turnUtils'

import { ConnectedChatHistory } from './ConnectedChatHistory'

export const ConnectedChatHeader = () => {
  const {
    historyEnabled,
    setOpen,
    visualizationMode,
    setVisualizationMode,
    lockVisualizationMode,
    tracking,
    credits,
    employeeCredits,
    messages,
    clear,
    loadThread,
    currentThreadTitle,
  } = useAiChat()
  const [isHistoryOpen, setIsHistoryOpen] = useState(false)
  const fullscreen = visualizationMode === 'fullscreen'

  const filteredMessages = useMemo(() => filterNonRenderableMessages(messages), [messages])
  const hasMessages = filteredMessages.length > 0

  const handleClose = useCallback(() => {
    if (fullscreen) {
      setVisualizationMode('sidepanel')
      setTimeout(() => setOpen(false), 200)
    } else {
      setOpen(false)
    }
    tracking?.onClose?.()
  }, [fullscreen, setVisualizationMode, setOpen, tracking])

  const handleToggleVisualizationMode = useCallback(() => {
    setVisualizationMode((prev) => (prev === 'fullscreen' ? 'sidepanel' : 'fullscreen'))
  }, [setVisualizationMode])

  const handleNewChat = useCallback(() => {
    tracking?.onNewChat?.()
    clear()
  }, [tracking, clear])

  const handleSelectThread = useCallback(
    (threadId: string, threadTitle: string) => {
      loadThread(threadId, threadTitle)
    },
    [loadThread]
  )

  const handleHistoryNewChat = useCallback(() => {
    tracking?.onNewChat?.()
    clear()
  }, [tracking, clear])

  return (
    <>
      <F0AiChatHeader
        historyEnabled={historyEnabled}
        currentThreadTitle={currentThreadTitle}
        fullscreen={fullscreen}
        lockVisualizationMode={lockVisualizationMode}
        onToggleVisualizationMode={handleToggleVisualizationMode}
        onClose={handleClose}
        onNewChat={handleNewChat}
        onOpenHistory={() => setIsHistoryOpen(true)}
        hasMessages={hasMessages}
        credits={credits}
        employeeCredits={employeeCredits}
      />
      {isHistoryOpen && historyEnabled && (
        <ConnectedChatHistory
          onClose={() => setIsHistoryOpen(false)}
          onSelectThread={handleSelectThread}
          onNewChat={handleHistoryNewChat}
        />
      )}
    </>
  )
}
